export class PathHandler {
  handle(pathData) {
    return pathData;
  }
}
